export const handleErrorMessages = (e: any) => {
  const message = e?.message?.toLowerCase() || '';

  if (message.includes('opening pop-up')) {
    // Error related to opening the pop-up window for authentication (common in social logins)
    return 'Unable to sign in with social login. Please try again.';
  } else if (message.includes('closed login window')) {
    // User closed the login window (common in social logins)
    return 'User rejected the request or closed the login window.';
  } else if (message.includes('user rejected')) {
    // Specific error when a user rejects the wallet connection request
    return 'User rejected the wallet connection request.';
  } else if (message.includes('user denied')) {
    // Error when the user denies the permission to connect their wallet
    return 'You denied the wallet connection request.';
  } else if (message.includes('network error')) {
    // Network issues when trying to connect to the wallet (e.g., provider not available)
    return 'Network error. Please check your connection and try again.';
  } else if (message.includes('user cancelled')) {
    // User cancelled the wallet connection request
    return 'Wallet connection request was cancelled by the user.';
  } else if (message.includes('unknown')) {
    // Generic error for unknown issues
    return 'Something went wrong. Please try again.';
  } else {
    // Default fallback error handling for any other unhandled errors
    return 'An unknown error occurred. Please try again later.';
  }
};
